
export const getStylesBookingCalendar = ( { stylesCalendar , stylesInputCalendar , template , calendarIcon , mergeDates , arrowIcon , calendarConfigs , bookingFieldsDate} ) => {

    let paddingTop = ''
    let paddingBottom = ''
    let paddingLeft = ''
    if(template === 'fixed'){
        const paddings = stylesInputCalendar.padding.split(' ')
        paddingTop = paddings[0]
        paddingBottom = paddings[2]
        paddingLeft = paddings[3]
    }
    let widthContainerCalendars = '350px'
    let widthCalendar = '350px'
    let widthDay= '50px'
    let lineHeight= '40px'

    if( window.screen.width > 1200 ){

        if( template === 'half-width' ){
            widthContainerCalendars = calendarConfigs.calendarsCount == 2 ? '620px' : '400px',
            widthCalendar = calendarConfigs.calendarsCount == 2 ? '300px' : '400px',
            widthDay = '40px',
            lineHeight = '35px'
        }else if( template === 'fixed'){
            widthContainerCalendars = calendarConfigs.calendarsCount == 2 ? '620px' : '400px',
            widthCalendar = calendarConfigs.calendarsCount == 2 ? '50%' : '400px',
            widthDay = '40px',
            lineHeight = '35px'
        }else{
            widthContainerCalendars = calendarConfigs.calendarsCount == 2 ? '720px' : '400px',
            widthCalendar  = calendarConfigs.calendarsCount == 2 ? '350px' : '400px',
            widthDay = '50px',
            lineHeight = '40px'
        }
    }

    return {
        '--body-background-color' : stylesCalendar.backgroundColor,
        '--body-border-color': stylesCalendar.borderColor == 'transparent' ? `none` : `1px solid ${stylesCalendar.borderColor}`,

        '--header-background-color' : stylesCalendar.header.backgroundColor,
        '--header-font-family' : stylesCalendar.header.fontFamily,
        '--header-font-size' : stylesCalendar.header.fontSize,
        '--header-letter-spacing' : stylesCalendar.header.letterSpacing,
        '--header-font-weight' : stylesCalendar.header.fontWeight,
        '--header-font-style' : stylesCalendar.header.fontStyle,
        '--header-color' : stylesCalendar.header.color,
        '--header-text-transform' : stylesCalendar.header.textTransform,

        '--weekdays-background-color' : stylesCalendar.weekdays.backgroundColor,
        '--weekdays-font-family' : stylesCalendar.weekdays.fontFamily,
        '--weekdays-font-size' : stylesCalendar.weekdays.fontSize,
        '--weekdays-letter-spacing' : stylesCalendar.weekdays.letterSpacing,
        '--weekdays-font-weight' : stylesCalendar.weekdays.fontWeight,
        '--weekdays-font-style' : stylesCalendar.weekdays.fontStyle,
        '--weekdays-color' : stylesCalendar.weekdays.color,
        '--weekdays-text-transform' : stylesCalendar.weekdays.textTransform,

        '--days-font-family' : stylesCalendar.days.fontFamily,
        '--days-font-size' : stylesCalendar.days.fontSize,
        '--days-font-weight' : stylesCalendar.days.fontWeight,
        '--days-active-background-color' : stylesCalendar.days.active.backgroundColor,
        '--days-active-color' : stylesCalendar.days.active.color,
        '--days-current-background-color' : stylesCalendar.days.current.backgroundColor,
        '--days-current-color' : stylesCalendar.days.current.color,
        '--days-between-background-color' : stylesCalendar.days.between.backgroundColor,
        '--days-between-color' : stylesCalendar.days.between.color,
        '--days-hover-background-color' : stylesCalendar.days.hover.backgroundColor,
        '--days-hover-color' : stylesCalendar.days.hover.color,
        '--days-default-color' : stylesCalendar.days.default.color,

        '--width-container-calendars' : widthContainerCalendars,
        '--width-calendar' :  widthCalendar,
        '--width-day' : widthDay,
        '--line-height-day': lineHeight,

        '--margin-calendar' : template === 'fixed' ? '0px' : '10px',

        '--icon-arrow-calendar' : `url(${arrowIcon})`,
      

        //Fixed calendar
        '--input-border-right': template === 'fixed' ? stylesInputCalendar.border.right : '',
        '--input-border-left': template === 'fixed' ? stylesInputCalendar.border.left : '',
        '--input-border-bottom': template === 'fixed' ? stylesInputCalendar.border.bottom : '',
        '--input-border-top': template === 'fixed' ? stylesInputCalendar.border.top : '',
        '--input-padding-top': template === 'fixed' ? paddingTop: '',
        '--input-padding-bottom': template === 'fixed' ? paddingBottom : '',
        '--input-padding-left': template === 'fixed' ? paddingLeft: '',
        '--input-font-family': template === 'fixed' ? stylesInputCalendar.fontFamily : '',
        '--input-font-size': template === 'fixed' ? stylesInputCalendar.fontSize : '',
        '--input-label-font-size': template === 'fixed' ? stylesInputCalendar.fontSizeLabel : '',
        '--input-font-weight': template === 'fixed' ? stylesInputCalendar.fontWeight : '',
        '--input-letter-spacing': template === 'fixed' ? stylesInputCalendar.letterSpacing : '',
        '--input-line-height': template === 'fixed' ? stylesInputCalendar.lineHeight : '',
        '--input-text-transform': template === 'fixed' ? stylesInputCalendar.textTransform : '',
        '--input-color': template === 'fixed' ? stylesInputCalendar.color : '',
        '--input-width' : template ?  (mergeDates ? '110px' : '155px') : '',

        '--input-first-border-right' : template === 'fixed' ? (mergeDates ? 'none' : stylesInputCalendar.border.right) : '',
        '--input-last-border-left' : template === 'fixed' ? (mergeDates ? 'none' : stylesInputCalendar.border.left) : '',
        '--input-first-margin-right': template === 'fixed' ? (mergeDates ? 'inherit' : '20px') : '',

        '--input-container-width': template === 'fixed' ? (mergeDates ? '22%' : '35%') : '',
        '--input-first-width': template === 'fixed' ? (mergeDates ? '100px' : '155px') : '155px',
        '--input-first-background': template === 'fixed' ? (mergeDates ? 'none' : `url(${calendarIcon})`) : `url(${calendarIcon})`,

        '--input-calendar-icon': template === 'fixed' ? `url(${calendarIcon})` : ''

    }
}


export const isLightColor = ( color = '' ) => {
    if ( color === undefined || color === '' ) {
        return false;
    }

    let r, g, b, hsp;
    
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
        r = color[1];
        g = color[2];
        b = color[3];
    } 
    else {
        
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    return hsp > 127.5;
}

